import { Box, Button, Grid, IconButton, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { UserDetailProps } from "./types"
import { icons } from "../../../../../../../../utils/icons"
import { useStyles } from "./styles"
import { FiltersDrawer } from "../../../../../../../../components/filtersDrawer"
import { DinamicForm } from "../../../../../../../../components/dinamicForm"
import { CustomPaper } from "../../../../../../../../components/CustomPaper"
import { NewListTooltipDetail } from "../../../../../../../../components/newListTooltipDetail"
import { KeyCaptionVertical } from "../../../../../../../../components/detailKeyValue/keyCaption.index"
import { CustomTable, SnackSimple } from "../../../../../../../../components"
import SimpleModal from "../../../../../../../../components/modal/simpleModal"
import { useContextState } from "../../../../../../../../hooks/theme"
import { LoadingButton } from "@mui/lab"


export const UserDetailFile = ({ disabled, loadingSaveUserFiles, closeOpenSnakbar, openSnackbar, loadingDeleteFiles, totalPagesDetail, tableUserLoading, user, unSelectOrSelectAllFiles, saveUserList, handleFilesList, isChecked, detailFilter, input, deletedUsersSelecteds, deleteSelected, goBackToList, columnDetail, rowDetail, openModal, closeModal }: UserDetailProps) => {


    const { t } = useTranslation()
    const styles = useStyles()
    const { colors } = useContextState()

    return (
        <Box sx={{}}>
            <Box sx={styles.headerLeft}>
                <IconButton onClick={goBackToList}>{icons('arrow-left-fill')}</IconButton>
                <Typography>{t('filesManager.buttons.backToListSecond')}</Typography>
            </Box>

            <FiltersDrawer cleanFilter={detailFilter.cleanFilter} count={detailFilter.counter} right={0} top={90}>
                <Box sx={styles.section}>
                    <DinamicForm errors={detailFilter.errors} input={Object.values(input)} values={detailFilter.filterData} onChange={detailFilter.onChange} filter={true} legacyErrors />
                </Box>
            </FiltersDrawer>

            <Box sx={styles.header}>
                <Typography sx={styles.title}>{user.name}</Typography>

                <Box sx={styles.flex}>
                    {!!detailFilter.counter && <IconButton
                        sx={(styles.clean, (detailFilter.counter || 0) > 0 ? null : styles.hide)}
                        onClick={() => {
                            detailFilter.cleanFilter()
                        }}
                    >
                        {icons('clean')}
                    </IconButton>
                    }
                </Box>
            </Box>

            <Grid container spacing={5}>
                <Grid item xs={12} sm={12} md={12} lg={4} xl={3} sx={styles.grid}>
                    <Typography sx={styles.title}>{t('filesManager.subtitles.aboutTheUser')}</Typography>

                    <CustomPaper elevation={3} sx={styles.paper}>
                        <KeyCaptionVertical value={t('filesManager.tags.role')} caption={user.role} valueProps={{ sx: { width: '39%' } }} captionProps={{ sx: { width: '59%' } }} center />

                        <KeyCaptionVertical value={t('filesManager.tags.area')} caption={<NewListTooltipDetail list={user.area || []} isBold />} valueProps={{ sx: { width: '39%' } }} captionProps={{ sx: { width: '59%' } }} center />

                        <KeyCaptionVertical value={t('filesManager.tags.department')} caption={<NewListTooltipDetail list={user.department || []} isBold />} valueProps={{ sx: { width: '39%' } }} captionProps={{ sx: { width: '59%' } }} center />

                        <KeyCaptionVertical value={t('filesManager.tags.userType')} caption={user.userType} valueProps={{ sx: { width: '39%' } }} captionProps={{ sx: { width: '59%' } }} center />
                    </CustomPaper>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={8} xl={9}>
                    <Box sx={styles.containerTitleAndButtons}>
                        <Typography sx={styles.title}>{t('filesManager.subtitles.fileList')}</Typography>

                        <Box sx={styles.containerButtons}>
                            <Box sx={styles.all}>
                                <Typography
                                    sx={styles.select}
                                    onClick={() => {
                                        unSelectOrSelectAllFiles({ value: true })
                                    }}
                                >
                                    {t('schedule.buttons.addTruechecket')}
                                </Typography>

                                <Typography
                                    sx={styles.select}
                                    onClick={() => {
                                        unSelectOrSelectAllFiles({ value: false })
                                    }}
                                >
                                    {t('schedule.buttons.addFalsechecket')}
                                </Typography>
                            </Box>

                            {(deleteSelected.length > 0 || isChecked) &&
                                <LoadingButton
                                    loading={loadingDeleteFiles}
                                    onClick={deletedUsersSelecteds}
                                    variant="container_error"
                                >
                                    {t('filesManager.buttons.delete')}
                                </LoadingButton>
                            }

                            <Button sx={styles.buttonNext} variant="contained" onClick={handleFilesList}>
                                {t('filesManager.buttons.addFile')}
                            </Button>

                            <LoadingButton disabled={disabled} loading={loadingSaveUserFiles} sx={styles.buttonNext} variant="contained" onClick={saveUserList}>
                                {t('general.save')}
                            </LoadingButton>
                        </Box>
                    </Box>

                    <Box sx={styles.containerTable}>
                        <CustomTable
                            name="Informe General"
                            dontRefresh
                            serverSidePagination={{ page: detailFilter.paginationModel.page + 1, size: detailFilter.paginationModel.pageSize, totalPages: totalPagesDetail }}
                            handleChange={(page: number, pageSize: number) => {
                                detailFilter.handlePagination({ page, pageSize })
                            }}
                            order={
                                detailFilter.query?.sort && {
                                    count: detailFilter.query?.sort?.count,
                                    key: detailFilter.query?.sort?.field,
                                    order: detailFilter.query?.sort?.sort,
                                }
                            }
                            sortable={(field, sort, count) => {
                                detailFilter.sortTable(field && sort ? { field: field, sort: sort, count } : undefined)
                            }}
                            column={columnDetail}
                            loader={tableUserLoading}
                            row={rowDetail}
                            color={colors}
                            selected={-1}
                        />


                    </Box>
                </Grid>
            </Grid>

            <SimpleModal
                open={!!openModal.open}
                next={openModal.confirm}
                back={closeModal}
                close={closeModal}
                description={openModal.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                title={openModal.title}
                loadingButton={false}
                sx={{
                    width: '400px'
                }}
                containerBox={{
                    sx: {
                        height: '150px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    },
                }}
            />

            <SnackSimple
                close={closeOpenSnakbar}
                open={openSnackbar.open}
                type={openSnackbar.type}
                message={openSnackbar.message}
            />
        </Box>
    )
}